// extracted by mini-css-extract-plugin
export default {"roadList":"AdminDashboard_roadList__7oh8f","roadItem":"AdminDashboard_roadItem__vHSgq","cvGenWrapper":"AdminDashboard_cvGenWrapper__x-DWz","dots":"AdminDashboard_dots__41hET"};